import { Outlet } from 'react-router-dom';
import Header from './Header';

/**
 * Layout principal de la aplicación
 * Contiene Header y el contenido de cada página
 */
const Layout = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <main className="flex-1 container mx-auto px-4 py-6 max-w-7xl">
        <Outlet />
      </main>

      <footer className="bg-white border-t border-red-100 py-4">
        <div className="container mx-auto px-4 text-center text-sm text-gray-500">
          <p>
            <span className="font-medium text-red-400">TuPlan Sociales</span>
            {' · '}
            Gestión Educativa Perú (GEP) © 2026
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
